var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValuepropsMec2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 52,
  fill: "none",
  fillOpacity: 0,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M18.267 1.604A.626.626 0 0 1 19.375 2v18c0 .345-.28.625-.625.625H5.25a.626.626 0 0 1-.543-.935l7.715-13.5.043-.066a.63.63 0 0 1 .462-.248.63.63 0 0 1 .54.252l1.244 1.68 3.496-6.119z"
})));
export default SvgValuepropsMec2;